import * as types from "../types";

export function saveToken(Token) {
  return {
    type: types.SAVE_TOKEN,
    Token,
  };
}

export const loginInfo = (payload) => ({
  type: types.LOGIN_INFO,
  payload,
});

export function deleteToken() {
  return {
    type: types.DELETE_TOKEN,
  };
}

// export function setProvinces(data) {
//   return {
//     type: types.SET_PROVINCES,
//     data,
//   };
// }

export function setCredit(credit) {
  return {
    type: types.SET_CREDIT,
    credit,
  };
}


export function setMobile(mobile) {
  return {
    type: types.SET_MOBILE,
    mobile,
  };
}

export function setFirstName(firstName) {
  return {
    type: types.SET_FIRST_NAME,
    firstName,
  };
}

export function setLastName(lastName) {
  return {
    type: types.SET_LAST_NAME,
    lastName,
  };
}

export function setCode(code) {
  return {
    type: types.SET_CODE,
    code,
  };
}

export function newUpload() {
  return {
    type: types.NEW_UPLOAD,
  };
}
export function SetPermission(permission) {
  return {
    type: types.SET_PERMISSION,
    permission,
  };
}

export function SetSummary(summary) {
  return {
    type: types.SET_DASHBOARDSUMMARY,
    summary,
  };
}
